<template>
  <v-container class="c-claims app-bg">
    <v-layout column v-if="value">
      <v-flex v-for="item in value.claims" :key="item.name">
        <h3>{{ item.name }}</h3>
        <p v-html="item.content"></p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    value: Object
  }
};
</script>

<style lang="scss" scoped>
.c-claims {
  h3 {
    margin: 20px 0 5px;
  }
}
</style>
